






import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Vuetify from 'vuetify';

Vue.use(Vuetify);

export default class AppComponent extends Vue {
}
